import { render, staticRenderFns } from "./ExchangeGift.vue?vue&type=template&id=db1e80ba&scoped=true&"
import script from "./ExchangeGift.vue?vue&type=script&lang=js&"
export * from "./ExchangeGift.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeGift.vue?vue&type=style&index=0&id=db1e80ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1e80ba",
  null
  
)

export default component.exports